import React, { FC, ReactElement, useEffect } from 'react';
import { Alert } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Prompt } from 'react-router-dom';
import ErrorMessage from '../../components/common/ErrorMessage';
import ParseHtml from '../../components/common/ParseHtml';
import withLocalization from '../../components/hoc/withLocalization';
import AlternateLOCInput from '../../components/OfferDestination/AlternateLOCInput';
import ViewDestination from '../../components/OfferDestination/DestinationInformation';
import FlipOffer from '../../components/OfferDestination/FlipOffer';
import ViewDestinationHeader from '../../components/OfferDestination/ViewDestinationHeader';
import { NavigationSteps } from '../../components/OfferDetails/OfferNavigation';
import { isSessionExpired } from '../../redux/middleware';
import { RootState } from '../../redux/rootReducer';
import { VIEW_OFFERS_PATH } from '../../util/strings';
import { releaseHoldProperty, resetADACodes, resetNavigationStatus } from '../offerAvailability/offerAvailabilitySlice';
import { ReleaseHoldPropertyRequest } from '../offerAvailability/types';
import { resetConfirmationError } from '../offerConfirmation/offerConfirmationSlice';
import {
  resetGuestsAndState,
  resetSearchMode,
  setCurrentOffer,
  // eslint-disable-next-line prettier/prettier
  setNavigationStep
} from '../offerSearch/offerSearchSlice';
import { Offer } from '../offerSearch/types';

const OfferDestinationContainer: FC<any> = (props: any): ReactElement => {
  const dispatch = useDispatch();
  const { localize } = props;
  const holdSessionId = useSelector((state: RootState) => state.availabilityDates.holdSessionId);
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(resetSearchMode(''));
    dispatch(resetGuestsAndState());
    dispatch(setNavigationStep(NavigationSteps.OFFER_DESTINATION));
    dispatch(resetNavigationStatus());
    dispatch(resetADACodes());
    dispatch(resetConfirmationError());
  }, [dispatch]);

  useEffect(() => {
    if (holdSessionId) {
      const releaseRequest: ReleaseHoldPropertyRequest = {
        holdId: holdSessionId,
      };
      dispatch(releaseHoldProperty(releaseRequest));
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [holdSessionId]);

  const onHandleClicked = (index) => {
    dispatch(setCurrentOffer(index));
    props.history.push(VIEW_OFFERS_PATH);
  };
  const primaryOffer: Offer[] | undefined = useSelector((state: RootState) => state.offerDetails.primaryOffer);
  const flipOffers: Offer[] | undefined = useSelector((state: RootState) => state.offerDetails.flipOffers);
  const hasErrors: boolean = useSelector((state: RootState) => state.offerDetails.hasError);
  const errorObj = useSelector((state: RootState) => state.offerDetails.error);
  const error = hasErrors ? <ErrorMessage errorObject={errorObj}></ErrorMessage> : <></>;
  const allPrimaryOffersExcluded =
    primaryOffer && primaryOffer.filter((x) => x.includeOffer === false).length === primaryOffer.length ? true : false;
  const allFlipOffresExcluded =
    flipOffers && flipOffers.filter((x) => x.includeOffer === false).length === flipOffers.length ? true : false;
  const hasPrimaryOffers = primaryOffer && primaryOffer.length > 0;
  const lastActiveTime = useSelector((state: RootState) => state.sessionManager).lastActiveTime;
  return (
    <>
      <div className="container">
        <Prompt when={true} message={() => !isSessionExpired(lastActiveTime)}></Prompt>
        {error}
        <ViewDestinationHeader />
        <AlternateLOCInput />
        {!hasPrimaryOffers && (
          <Alert variant="warning">
            <ParseHtml
              htmlInput={localize('preview-sales-engine.static-content.copy.select-destination-page.no-primary-offers')}
            ></ParseHtml>
          </Alert>
        )}
        {primaryOffer && !allPrimaryOffersExcluded ? (
          primaryOffer.map((offer, index) => (
            <ViewDestination offer={offer} key={index} onViewOfferClicked={() => onHandleClicked(index)} />
          ))
        ) : allPrimaryOffersExcluded ? (
          <Alert variant="danger">
            {localize
              ? localize(
                  'preview-sales-engine.static-content.copy.select-destination-page.no-offers-found-for-selected-state-primary',
                )
              : ''}
          </Alert>
        ) : (
          <></>
        )}
        <FlipOffer flipOffers={flipOffers} allFlipOffresExcluded={allFlipOffresExcluded}></FlipOffer>
      </div>
    </>
  );
};
export default withLocalization(OfferDestinationContainer);
